enum DayOrMultiDayPickerMode {
  Single = 'single',
  Range = 'range',
}

export default DayOrMultiDayPickerMode;
